import FXSTTokenHistoryPageContainer from "../../Component/DepositFund/FXSTTokenHistory/FXSTTokenHistory"

const FXSTTokenHistoryPage = () => {
  return (
    <div className='page-body'>
      <FXSTTokenHistoryPageContainer />
    </div>
  )
}

export default FXSTTokenHistoryPage